import { render, staticRenderFns } from "./ResultTable.vue?vue&type=template&id=013c5d9a&scoped=true&"
import script from "./ResultTable.vue?vue&type=script&lang=js&"
export * from "./ResultTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013c5d9a",
  null
  
)

export default component.exports